export default {
  GET_GROUP_REQUEST: 'GROUP_GET_GROUP_REQUEST',
  GET_GROUP_SUCCESS: 'GROUP_GET_GROUP_SUCCESS',
  GET_GROUP_FAILURE: 'GROUP_GET_GROUP_FAILURE',

};
